import { render, staticRenderFns } from "./yunplat.vue?vue&type=template&id=2a76e41e&scoped=true"
import script from "./yunplat.vue?vue&type=script&lang=js"
export * from "./yunplat.vue?vue&type=script&lang=js"
import style0 from "./yunplat.vue?vue&type=style&index=0&id=2a76e41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76e41e",
  null
  
)

export default component.exports